<template>
  <table class="outer-table payment-table">
    <tr>
      <td v-for="(column, colIndex) in columns" :key="colIndex" style="vertical-align: top;">
        <table class="inner-table" :class="{ 'first-col': colIndex === 0 }">
          <!-- Заголовок -->
          <thead v-if="header && header.length">
            <tr>
              <th class="text-center">
                {{ header[0] }}
              </th>
              <th class="text-end text-nowrap">
                {{ header[1] }}
              </th>
            </tr>
          </thead>

          <!-- Тело -->
          <tbody>
            <tr v-for="(row, rowIndex) in column" :key="rowIndex">
              <td class="text-center" style="color: #8a8a8a">
                {{ row.number }}
              </td>
              <td class="text-end text-nowrap">
                {{ moneyMask(row.sum) }}
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </table>
</template>

<script>
import { moneyMask } from "@/run";

export default {
  name: "PaymentTableGrid",
  data() {
    return {
      moneyMask: moneyMask,
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },

    divisor: {
      type: Number,
      default: 2, // как в PHP: если 60 платежей → 30 столбцов
    },

    header: {
      type: Array,
      default: () => [], // ["Номер", "Сумма"]
    },
  },

  computed: {
    columns() {
      const total = this.items.length;
      const cols = Math.max(1, Math.ceil(total / this.divisor));
      const perCol = Math.ceil(total / cols);

      const chunks = [];
      for (let i = 0; i < total; i += perCol) {
        chunks.push(this.items.slice(i, i + perCol));
      }
      return chunks;
    },
  },
};
</script>

<style>
.outer-table {
  font-size: 12px;
  border-collapse: collapse;
}

.inner-table {
  width: 100%;
  border: 1px solid #ddd;
  margin: 0 0px;
}

.inner-table th,
.inner-table td {
  padding: 1.5px 5px;
  border: 1px solid #ffffff;
}

.inner-table th {
  color: #999;
  background: #fff;
  font-weight: normal;
}

.inner-table tbody tr:nth-child(6n + 1),
.inner-table tbody tr:nth-child(6n + 2),
.inner-table tbody tr:nth-child(6n + 3) {
  background-color: #f2f2f2;
}

.inner-table tbody tr:nth-child(6n + 4),
.inner-table tbody tr:nth-child(6n + 5),
.inner-table tbody tr:nth-child(6n + 6) {
  background-color: #ffffff;
}

.inner-table tbody tr:nth-child(6n + 1) td:first-child {
  border-top-left-radius: 8px;
}

.inner-table tbody tr:nth-child(6n + 1) td:last-child {
  border-top-right-radius: 8px;
}

.inner-table tbody tr:nth-child(6n + 3) td:first-child {
  border-bottom-left-radius: 8px;
}

.inner-table tbody tr:nth-child(6n + 3) td:last-child {
  border-bottom-right-radius: 8px;
}

.inner-table tbody tr:nth-child(6n + 6) td:first-child {
  border-top-left-radius: 8px;
}

.inner-table tbody tr:nth-child(6n + 6) td:last-child {
  border-top-right-radius: 8px;
}

.inner-table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 8px;
}

.inner-table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 8px;
}

.inner-table.first-col thead th {
  color: #8a8a8a;
}

.inner-table:not(.first-col) thead th {
  color: #fff;
}

@media (max-width: 1391px) {
  .payment-table {
    display: none;
  }
}

</style>